/* Cada pantalla se descarga por separado, cuando se abre por primera vez (antes iban TODAS en un solo archivo
   de ~4,8 MB que había que bajar antes de ver siquiera el ingreso). La clave es la ruta en minúsculas.
   Precarga.js baja en segundo plano las del menú del usuario, así al abrirlas ya están listas. */
const PANTALLAS = {
  '/laorden': () => import('./Components/pages/Laorden').then((m) => ({ default: m.Laorden })),
  '/register': () => import('./Components/pages/Register'),
  '/resultados': () => import('./Components/formas/Resultados'),
  '/labordenpago': () => import('./Components/Forms/Labordenpago'),
  '/examenemp': () => import('./Components/formas/Examenemp'),
  '/lista': () => import('./Components/formas/Lista'),
  '/consultav3': () => import('./Components/formas/Consultav3'),
  '/mediospago': () => import('./Components/formas/Mediospago'),
  '/undnegocios': () => import('./Components/formas/Undnegocios'),
  '/agencias': () => import('./Components/formas/Agencias'),
  '/combos': () => import('./Components/formas/Combos'),
  '/combosdet': () => import('./Components/formas/Combosdet'),
  '/feriados': () => import('./Components/formas/Feriados'),
  '/ipsconsec': () => import('./Components/formas/Ipsconsec'),
  '/labdepends': () => import('./Components/formas/Labdepends'),
  '/labempresas': () => import('./Components/formas/Labempresas'),
  '/lablistas': () => import('./Components/formas/Lablistas'),
  '/labseccion': () => import('./Components/formas/Labseccion'),
  '/labvalores': () => import('./Components/formas/Labvalores'),
  '/medicos': () => import('./Components/formas/Medicos'),
  '/ocupaciones': () => import('./Components/formas/Ocupaciones'),
  '/tipomuestras': () => import('./Components/formas/Tipomuestras'),
  '/unidades': () => import('./Components/formas/Unidades'),
  '/vinculaciones': () => import('./Components/formas/Vinculaciones'),
  '/opciones': () => import('./Components/formas/Opciones'),
  '/roleopcion': () => import('./Components/formas/Roleopcion'),
  '/roles': () => import('./Components/formas/Roles'),
  '/usuarios': () => import('./Components/formas/Usuarios'),
  '/dashboard': () => import('./Components/formas/Dashboard'),
  '/labtarifas': () => import('./Components/formas/Labtarifas'),
  '/pacientes': () => import('./Components/formas/Pacientes'),
  '/usuariorole': () => import('./Components/formas/Usuariorole'),
  '/examenana': () => import('./Components/formas/Examenana'),
  '/labnormal': () => import('./Components/formas/Labnormal'),
  '/zbi': () => import('./Components/formas/Zbi'),
  '/reglasimp': () => import('./Components/formas/Reglasimp'),
  '/ordenlab': () => import('./Components/formas/Ordenlab'),
  '/pacientesing': () => import('./Components/formas/Pacientesing'),
  '/interfazruby': () => import('./Components/formas/InterfazRuby'),
  '/interfazfus2000': () => import('./Components/formas/InterfazFus2000'),
  '/orderpincapture': () => import('./Components/formas/OrderPinCapture'),
  '/uploadimages': () => import('./Components/formas/Uploadimages'),
  '/repanexo': () => import('./Components/formas/RepAnexo'),
  '/interfaces': () => import('./Components/formas/Interfaces'),
  '/rips': () => import('./Components/formas/Rips'),
  '/descargarjson': () => import('./Components/formas/DescargarJson'),
  '/logcaja': () => import('./Components/formas/Logcaja'),
  '/bonosreyfals': () => import('./Components/formas/Bonosreyfals'),
  '/facturacion': () => import('./Components/formas/Facturacion'),
  '/consulta': () => import('./Components/formas/Consulta'),
  '/cartera': () => import('./Components/formas/Cartera'),
  '/cargaimagens3': () => import('./Components/formas/CargaImagenS3'),
  '/diagnosticos': () => import('./Components/formas/Diagnosticos'),
  '/consultafacturas': () => import('./Components/formas/Consultafacturas'),
  '/entregares': () => import('./Components/formas/Entregares'),
  '/usupendientes': () => import('./Components/formas/Usupendientes'),
  '/tracking': () => import('./Components/formas/Tracking'),
  '/landsticker': () => import('./Components/formas/Landsticker'),
  '/funnel': () => import('./Components/formas/Funnel'),
  '/consultadep': () => import('./Components/formas/Consultadep'),
};
PANTALLAS['/mediodepagos'] = PANTALLAS['/mediospago'];

/* Si una pantalla no baja (se publicó una versión nueva mientras el usuario tenía el panel abierto y el archivo viejo
   ya no existe, o se cortó la red), se recarga la página UNA vez para traer la versión vigente. */
export function cargarPantalla(ruta) {
  const cargar = PANTALLAS[String(ruta).toLowerCase()];
  return () => cargar().then(
    (m) => { try { sessionStorage.removeItem('sym-recarga'); } catch (e) { /* nada */ } return m; },
    (error) => {
      let yaRecargo = false;
      try { yaRecargo = sessionStorage.getItem('sym-recarga') === '1'; sessionStorage.setItem('sym-recarga', '1'); } catch (e) { /* nada */ }
      if (!yaRecargo) { window.location.reload(); return new Promise(() => {}); }
      throw error;
    }
  );
}

export function precargar(ruta) {
  const cargar = PANTALLAS[String(ruta || '').toLowerCase()];
  return cargar ? cargar().catch(() => {}) : Promise.resolve();
}

export default PANTALLAS;
